
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/become-partner",
      function () {
        return require("private-next-pages/become-partner.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/become-partner"])
      });
    }
  